import React from 'react';
import { useSearchParams } from 'react-router-dom';
import DatabaseBackups from './DatabaseBackups';

const AgencyHubPanel = ({ user, onRefresh }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeSection = searchParams.get('subsection') || 'database-backups';
  const setActiveSection = (section) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('subsection', section);
      return next;
    });
  };

  const renderSectionContent = () => {
    switch (activeSection) {
      case 'database-backups':
        return <DatabaseBackups user={user} noWrapper={true} />;

      default:
        return null;
    }
  };

  return (
    <div className="super-admin-internal-layout">
      <nav className="internal-nav">
        <div className="internal-nav-items">
          <button
            className={`internal-nav-btn ${activeSection === 'database-backups' ? 'active' : ''}`}
            onClick={() => setActiveSection('database-backups')}
            data-onboarding="database-backups-tab"
          >
            Database Backups
          </button>
        </div>
      </nav>
      <div className="internal-content">
        {renderSectionContent()}
      </div>
    </div>
  );
};

export default AgencyHubPanel;
